module.exports = __webpack_public_path__ + "img/conclusion-disease-detail.981ad4eb.jpg";